export default __webpack_public_path__ + "static/pools-3ce384d4647ce26fbe37f51ada11c2bc.jpg";